import { TMasterCompanyMainSkill } from "@/api/entities/master-company-main-skill.entity";
import { setHiddenCompanyMainSkillApi } from "@/api/services/global/master";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { toNumberOrNull } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Dispatch, FC, SetStateAction } from "react";

type THiddenCompanyMainSkillModalProps = {
  hiddenCompanyMainSkill?: TMasterCompanyMainSkill;
  setHiddenCompanyMainSkill: Dispatch<SetStateAction<TMasterCompanyMainSkill | undefined>>;
  setCompanyMainSkillRows: React.Dispatch<React.SetStateAction<TMasterCompanyMainSkill[]>>;
  existingCompanySpecificIndustryId: number;
};

export const HiddenCompanyMainSkillModal: FC<THiddenCompanyMainSkillModalProps> = ({
  hiddenCompanyMainSkill,
  setHiddenCompanyMainSkill,
  setCompanyMainSkillRows,
  existingCompanySpecificIndustryId,
}) => {
  const queryClient = useQueryClient();

  const handleSubmit = async () => {
    if (!hiddenCompanyMainSkill) {
      return;
    }

    const companySpecificIndustryId = toNumberOrNull(existingCompanySpecificIndustryId);
    const companySpecificBusinessClassificationId = toNumberOrNull(hiddenCompanyMainSkill.companySpecificBusinessClassificationId);
    const mainSkillId = toNumberOrNull(hiddenCompanyMainSkill.id);
    if (companySpecificIndustryId === null || companySpecificBusinessClassificationId === null || mainSkillId === null) {
      return;
    }

    try {
      const rs = await setHiddenCompanyMainSkillApi(companySpecificIndustryId, companySpecificBusinessClassificationId, mainSkillId, {
        isHidden: !hiddenCompanyMainSkill.isHidden,
      });
      toast.success(API_SUCCESS_MESSAGE);
      setHiddenCompanyMainSkill(undefined);
      const savedId = toNumberOrNull(rs.data.id);
      setCompanyMainSkillRows((prev) => prev.map((item) => (savedId !== null && toNumberOrNull(item.id) === savedId ? rs.data : item)));
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_COMPANY_SPECIFIC_INDUSTRY] });
    } catch (error) {
      setHiddenCompanyMainSkill(undefined);
      showError(error);
    }
  };

  return (
    <Modal
      title={hiddenCompanyMainSkill?.isHidden ? "有効化の確認" : "無効化の確認"}
      isOpen={!!hiddenCompanyMainSkill}
      onClose={() => setHiddenCompanyMainSkill(undefined)}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      onOk={() => handleSubmit()}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {hiddenCompanyMainSkill?.isHidden ? "この行が有効化されますが、よろしいですか。" : "この行が無効化されますが、よろしいですか。"}
      </Typography>
    </Modal>
  );
};
